import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Also clean on page load (for when returning to the page)
    this.clean()
  }

  clean() {
    const url = new URL(window.location)

    this.#removeParams(url.searchParams)

    const search = url.searchParams.toString()
    const newUrl = search ? `${url.pathname}?${search}` : url.pathname

    window.history.replaceState({}, '', newUrl)
  }


  // eslint-disable-next-line class-methods-use-this
  #removeParams(params) {
    const paramsToRemove = ['commit', 'reset_filters']

    // Remove special params
    for (const param of paramsToRemove) {
      params.delete(param)
    }

    // Remove all empty params as well
    for (const [key, value] of [...params.entries()]) {
      if (!value || value.trim() === '') {
        params.delete(key)
      }
    }
  }
}
